import { FunctionalComponent, h } from "preact";
import styled, { css } from "styled-components";

const Wrapper = styled.div`
  color: red;
  ${(props) =>
    props.fixedBottom &&
    css`
      position: fixed;
      bottom: 40px;
      width: 100%;
      display: flex;
      justify-content: center;
    `};

  ${(props) =>
    props.fixedCenter &&
    css`
      position: fixed;
      bottom: 50vh;
      width: 100%;
      display: flex;
      justify-content: center;
    `};
`;

export const LoadingIndicator: FunctionalComponent = (props) => {
  return <Wrapper {...props}>LOADING...</Wrapper>;
};
